module.exports = __webpack_public_path__ + "static/unicorncomfblanket1-09ca4d92fb46e630de745615d4ef51e0.jpeg";